"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterSelectContext = exports.FilterSelectContextProvider = void 0;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../../utils");
var _ShowMore = require("../../ShowMore");
var _excluded = ["children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// In order to satisfy the Relay compilers readonly list types. This is in
// support for passing different kinds of item types as props, like aggregations

var filterSelectReducer = function filterSelectReducer(state, action) {
  switch (action.type) {
    case "SET_QUERY":
      {
        var _query = action.payload.query;
        if (_query === "") {
          return _objectSpread(_objectSpread({}, state), {}, {
            query: _query,
            isFiltered: false,
            filteredItems: []
          });
        }
        var filteredItems = state.items.filter(function (_ref) {
          var name = _ref.label;
          return name.toLowerCase().includes(_query.toLowerCase());
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          query: _query,
          isFiltered: true,
          filteredItems: filteredItems
        });
      }
    case "TOGGLE_SELECTED_ITEM":
      {
        var isFound = !!state.selectedItems.find(function (item) {
          return item.value === action.payload.item.value;
        });
        var selectedItems;
        if (isFound) {
          selectedItems = (0, _lodash.reject)(state.selectedItems, {
            value: action.payload.item.value
          });
        } else {
          selectedItems = state.multiselect ? [].concat(_toConsumableArray(state.selectedItems), [action.payload.item]) : [action.payload.item];
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedItems: selectedItems
        });
      }
    case "SET_SELECTED_ITEMS":
      {
        var _items = action.payload.items;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedItems: _items
        });
      }
  }
};
var initialState = {
  filteredItems: [],
  initialItemsToShow: _ShowMore.INITIAL_ITEMS_TO_SHOW,
  isFiltered: false,
  items: [],
  multiselect: true,
  onChange: function onChange(x) {
    return x;
  },
  order: [["label"], ["asc"]],
  placeholder: "",
  query: "",
  renderItemLabel: undefined,
  selectedItems: []
};
var FilterSelectContext = /*#__PURE__*/(0, _react.createContext)({});
var FilterSelectContextProvider = function FilterSelectContextProvider(_ref2) {
  var _props$selectedItems;
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useReducer = (0, _react.useReducer)(filterSelectReducer, _objectSpread(_objectSpread({}, initialState), props)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var contextValue = _objectSpread(_objectSpread({}, state), {}, {
    toggleSelectedItem: function toggleSelectedItem(item) {
      dispatch({
        type: "TOGGLE_SELECTED_ITEM",
        payload: {
          item: item
        }
      });
    },
    setQuery: function setQuery(query) {
      dispatch({
        type: "SET_QUERY",
        payload: {
          query: query
        }
      });
    },
    setSelectedItems: function setSelectedItems(items) {
      dispatch({
        type: "SET_SELECTED_ITEMS",
        payload: {
          items: items
        }
      });
    }
  });
  (0, _utils.useUpdateEffect)(function () {
    if (props.selectedItems) {
      contextValue.setSelectedItems(props.selectedItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(_props$selectedItems = props.selectedItems) === null || _props$selectedItems === void 0 ? void 0 : _props$selectedItems.length]);
  (0, _react.useLayoutEffect)(function () {
    var _props$query;
    if ((_props$query = props.query) !== null && _props$query !== void 0 && _props$query.length) {
      contextValue.setQuery(props.query);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(FilterSelectContext.Provider, {
    value: contextValue
  }, children);
};
exports.FilterSelectContextProvider = FilterSelectContextProvider;
FilterSelectContextProvider.displayName = "FilterSelectContextProvider";
var useFilterSelectContext = function useFilterSelectContext() {
  return (0, _react.useContext)(FilterSelectContext);
};
exports.useFilterSelectContext = useFilterSelectContext;
//# sourceMappingURL=FilterSelectContext.js.map